import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";

import {
  ESupportTicketSource,
  SupportTicketResponse,
} from "../../aiTickets.types";
import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import { requestTicketConversation } from "./ticketConversation.request";
import { TicketConversation } from "./ticketConversation.types";

const conversationIdOf = (ticket: SupportTicketResponse): string | null =>
  ticket.source === ESupportTicketSource.WhatsApp
    ? ticket.whatsappConversationId
    : ticket.inAppConversationId;

export const useTicketConversation = (ticket: SupportTicketResponse | null) => {
  const conversationId = ticket ? conversationIdOf(ticket) : null;

  const query = useQuery<TicketConversation, ApiServiceError<ApiError>>({
    queryKey: [
      SUPPORT_TICKETS_QUERY_KEY,
      "conversation",
      ticket?.source,
      conversationId,
    ],
    queryFn: async () =>
      await requestTicketConversation({
        source: ticket!.source,
        conversationId: conversationId!,
      }),
    enabled: Boolean(ticket && conversationId),
  });

  return { conversation: query.data ?? null, isLoading: query.isLoading };
};
